import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn, formatMonthLabel, getCurrentMonth, shiftMonth } from '@/lib/utils'

interface MonthSelectorProps {
  month: string
  onMonthChange: (month: string) => void
}

export function MonthSelector({ month, onMonthChange }: MonthSelectorProps) {
  const isAtCurrentMonth = month >= getCurrentMonth()

  return (
    <div className="sticky top-12 z-10 border-b bg-background/80 backdrop-blur">
      <div className="flex items-center justify-between px-4 py-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onMonthChange(shiftMonth(month, -1))}
        >
          <ChevronLeft className="size-5" />
        </Button>
        <span className="text-lg font-semibold">{formatMonthLabel(month)}</span>
        <Button
          variant="ghost"
          size="icon"
          disabled={isAtCurrentMonth}
          onClick={() => onMonthChange(shiftMonth(month, 1))}
        >
          <ChevronRight className={cn('size-5', isAtCurrentMonth && 'invisible')} />
        </Button>
      </div>
    </div>
  )
}
